export default __webpack_public_path__ + "static/media/login-video-1.772573c9.mp4";